/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState, useRef} from 'react'
import ApexCharts, {ApexOptions} from 'apexcharts'
import {getCSS, getCSSVariableValue} from '../../../../assets/ts/_utils'
import {useThemeMode} from '../../../layout/theme-mode/ThemeModeProvider'
import {useIntl} from 'react-intl'
import {useAuth} from '../../../../../app/modules/auth'
import {getCurriculumComparisonChart} from '../../../../../app/modules/curriculum/curricula-list/core/_requests'
import {
  ChartModel,
  initialChartModel,
} from '../../../../../_metronic/partials/widgets/charts/_models'
import {useYear} from '../../../../../_metronic/partials/layout/header-menus/YearsManager'
import {RoleModel} from '../../../../../app/modules/auth/core/_models'
import {useTerm} from '../../../layout/header-menus/TermsManager'

type Props = {
  className: string
  unitId?:number
  customerId?:number
}

const CurriculumComparisonChart: React.FC<Props> = ({className,unitId = undefined , customerId = undefined}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const {mode} = useThemeMode()
  const intl = useIntl()
  const {currentUser, auth} = useAuth()
  const currentYearId = useYear()
  const currentTermId = useTerm()

  useEffect(() => {
    let query = ''
    if (auth?.currentRole === RoleModel.Admin) query = '&academicYearId=' + currentYearId
    else if (auth?.currentRole === RoleModel.InstitutionManager)
      query = '&institutionId=' + currentUser?.institutionId + '&academicYearId=' + currentYearId
    else if (auth?.currentRole === RoleModel.Customer || auth?.currentRole === RoleModel.Person)
      query = '&customerId=' + currentUser?.customerId + '&academicYearId=' + currentYearId
    else
      query =
        '&institutionId=' +
        currentUser?.institutionId +
        '&subinstitutionId=' +
        currentUser?.subinstitutionId +
        '&academicYearId=' +
        currentYearId +
        '&termId=' +
        currentTermId +
        '&employeeId=' +
        currentUser?.employeeId +
        (unitId ? "&unitId=" + unitId:'')+
        (customerId ? "&customerId=" + customerId:'')
    getCurriculumComparisonChart(query).then((value) => {
      setCurriculumCoparisonChart(value)
    })
  }, [className,unitId,customerId])

  const [curriculumCoparisonChart, setCurriculumCoparisonChart] = useState<ChartModel | undefined>(
    initialChartModel
  )
  const refreshMode = () => {
    if (!chartRef.current) {
      return
    }
    const height = parseInt(getCSS(chartRef.current, 'height'))
    const chart = new ApexCharts(
      chartRef.current,
      getChartOptions(height, curriculumCoparisonChart)
    )

    if (chart) {
      chart.render()
    }

    return chart
  }

  useEffect(() => {
    const chart = refreshMode()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, curriculumCoparisonChart])

  function getChartOptions(
    height: number,
    curriculumCoparisonChart: ChartModel | undefined
  ): ApexOptions {
    const labelColor = getCSSVariableValue('--kt-gray-500')
    const borderColor = getCSSVariableValue('--kt-gray-200')
    const baseColor = getCSSVariableValue('--kt-primary')
    const secondaryColor = getCSSVariableValue('--kt-success')

    return {
        series: 
        curriculumCoparisonChart?.categories!.map((category, index) => ({
            name: category,
            data: [
              {
                x:  intl.formatMessage({id: '6ad'}),
                y:  curriculumCoparisonChart?.series1![index]/60, 
              },
              {
                x: intl.formatMessage({id: '6ae'}),
                y: curriculumCoparisonChart?.series2![index]/60,
              },
            ],
        })),
      chart: {
        height: 380,
        width: 420,
        type: 'line',
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false,
            reset: false,
            customIcons: [],
          },
        },
      },  markers: {
        size: 8, 
        strokeWidth: 2,
        hover: {
          size: 10,
        },
      },
    }
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'> {intl.formatMessage({id: '6ll'})}</span>
          <span className='text-muted fw-semibold fs-7'>{intl.formatMessage({id: '6ls'})}</span>
        </h3>
      </div>
      <div className='card-body'>
        <div ref={chartRef} id='kt_charts_widget_3_chart' style={{height: '350px'}}></div>
      </div>
    </div>
  )
}

export {CurriculumComparisonChart}
